module.exports = __webpack_public_path__ + "static/media/logo4.c622d207.png";